export default "__VITE_ASSET__BYiRbC1A__"